import React, { useState, useEffect } from "react";
import "./searching.css";
import { Typography, Space, Card, Button } from "antd";
import { Spin } from "antd";
import { getDetailsProduct } from "./api";
import { useMutation } from "react-query";


const Details = ({ currentId, setId }) => {
  const { Text, Title, Link } = Typography;
  const [detailsProduct, setDetailsProduct] = useState([]);
  const [user]= useState(JSON.parse(window.localStorage.getItem("loggedUser")))


  useEffect(()=>{
    if(currentId){
      mutation()
    }
  },[currentId])

  // useMutation
  const {mutate:mutation, isLoading}= useMutation((data)=>{
    return getDetailsProduct(user.jwtToken, currentId)
  },{
    onSuccess:(data)=>{
     setDetailsProduct(data?.data?.data[0]?.productDetails);
    }
  }
  )
  const handleId = (e) => {
    setId(null)
  };
  return (
    <div>
      <div style={{ width: "90%", height: "750px" }}>
        <div className="banner">
          <Text>
            <Title level={3} className="search_title">
              Search Products
            </Title>
          </Text>
          <Text>
            <Title level={5}>
              Find numerous unregistered products that can fulfill you need
            </Title>
          </Text>
        </div>
        <div className="link">
          <Link id={currentId} onClick={handleId}>
            {" "}
            <span className="link_text">Back to RFQ</span>{" "}
          </Link>
          {/* <Text type="secondary">/ {link}</Text> */}
        </div>
        {/* for showing cards data */}
        <div className="cad card_width">
          <Card>
            {isLoading ? (
              <div className="loader">
                <div>
                  <Spin />
                </div>
              </div>
            ) :   (
                  <div className="card_container">
                  <div>
                    <img
                      src={detailsProduct?.pic1}
                      alt="product image"
                      className="cards_images"
                    />
                    <br />
                    <br />
                    <div style={{ display: "flex", alignContent: "center" }}>
                      <div className="img-combo">
                        <img
                          src={detailsProduct?.pic2}
                          alt="image"
                          className="img-style"
                        />
                      </div>
                      <div className="img-combo">
                        <img
                          src={detailsProduct?.pic2}
                          alt="image"
                          style={{}}
                          className="img-style"
                        />
                      </div>
                      <div className="img-combo">
                        <img
                          src={detailsProduct?.pic2}
                          alt="image"
                          style={{ marginLeft: "15%" }}
                          className="img-style"
                        />
                      </div>
                    </div>
                    <br />
                    <br />
                    <Button style={{ backgroundColor: "#00ffb9"}} block>
                      Send RFI
                    </Button>
                  </div>
                  <Space direction="vertical" className="product_info">
                    <img src="" alt="Logo" />
                    {/* <Text>
                    <Link>
                      <strong className="card_link">{link}</strong>
                    </Link>
                  </Text> */}
                    <Text type="secondary">
                    Product ID: <Text>{currentId}</Text>
                  </Text>

                    <Text type="secondary">
                    Product Name:
                    <Text className="blue_text"> {detailsProduct?.api?.name}</Text>
                  </Text>

                    <Text type="secondary">
                    Country of Origin:
                    <Text className="blue_text"> {detailsProduct?.api?.countryOfOrigin}</Text>
                  </Text>

                    <Text type="secondary">
                    Approved By:
                    <Text className="blue_text"> {detailsProduct?.api?.approvedBy}</Text>
                  </Text>

                    <Text type="secondary">
                    Amounts:
                    <Text className="blue_text"> {detailsProduct?.amounts}</Text>
                  </Text>

                    <Text type="secondary">
                    Nature and Contents of Container:
                    <Text className="blue_text"> {detailsProduct?.natureAndContentsOfContainer}</Text>
                  </Text>

                    <Text type="secondary">
                    Packaging Details:
                    <Text className="blue_text"> {detailsProduct?.packagingDetails}</Text>
                  </Text>

                    <Text type="secondary">
                    Unit of Measure: <Text> {detailsProduct?.unitOfMeasure}</Text>
                  </Text>

                    <Text type="secondary">
                    Primary container type: <Text> {detailsProduct?.primaryContainerType}</Text>
                  </Text>

                    <Text type="secondary">
                    Dispensing Mode: <Text> {detailsProduct?.DispensingMode}</Text>
                  </Text>

                    <Text type="secondary">
                    Ingredients: <Text> {detailsProduct?.Ingredient}</Text>
                  </Text>

                      <Text type="secondary">
                    Dosage Form: <Text> {detailsProduct?.dosageForm}</Text>
                  </Text> 

                  <Text type="secondary">
                  Pack Size: <Text> {detailsProduct?.packSize}</Text>
                  </Text>

                  <Text type="secondary">
                    Product Category: <Text> {detailsProduct?.productCategoty}</Text>
                  </Text>
                  
                  <Text type="secondary">
                    Product Type: <Text> {detailsProduct?.productType}</Text>
                  </Text>

                  <Text type="secondary">
                    Strength Pr unit: <Text> {detailsProduct?.strengthPerUnit}</Text>
                  </Text>

                  <Text type="secondary">
                    Trade Name: <Text> {detailsProduct?.tradeName}</Text>
                  </Text>
                  </Space>
                </div>
              
            
            )}
          </Card>
        </div>
      </div>
    </div>
  );
};

export default Details;
